export class PriorityConst {
  static displayColumns = () => {
    return [
      {
        title: 'Tên mức ưu tiên',
        key: 'name',
        display: true,
        allowSort: false,
        classes: '',
      },
      {
        title: 'Kiểu',
        key: 'display_type',
        display: true,
        allowSort: false,
        classes: '',
      },
      {
        title: 'Mô tả',
        key: 'description',
        display: true,
        allowSort: false,
        classes: '',
      },
    ];
  };
  static displayTypeColumn = tenant_id => {
    if (tenant_id) {
      return `<span class="badge badge-default">Tự thiết lập</span>`;
    } else {
      return `<span class="badge badge-info">Mặc định</span>`;
    }
  };
}



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/setting/tickets/priority/priority.const.ts